const SplashScreen = {
    hide: () => {
    },
    show: () => {
    }
}

export default SplashScreen;
